import React from "react";
import { motion } from "framer-motion";

interface InspectionCardFooterProps {
  sheetDetailsLength: number;
  timeUntilTabSwitch: number;
  isDarkMode: boolean;
}

export const InspectionCardFooter: React.FC<InspectionCardFooterProps> = ({
  sheetDetailsLength,
  timeUntilTabSwitch,
  isDarkMode,
}) => {
  return (
    <div
      className={`py-0.5 px-2 flex justify-between items-center ${
        isDarkMode ? "bg-gray-700" : "bg-gray-100"
      }`}
    >
      {/* Indicador de auto-scroll */}
      <div
        className={`text-[9px] flex items-center gap-1 ${
          isDarkMode ? "text-gray-400" : "text-gray-600"
        }`}
      >
        <div className="flex gap-0.5">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              animate={{
                y: [0, -3, 0],
              }}
              transition={{
                duration: 0.8,
                repeat: Infinity,
                delay: i * 0.15,
              }}
              className={`w-1 h-1 rounded-full ${
                isDarkMode ? "bg-gray-500" : "bg-gray-400"
              }`}
            />
          ))}
        </div>
        <span>Auto Scroll</span>
      </div>

      {/* Contador regresivo para cambio de tab */}
      {sheetDetailsLength > 1 && (
        <motion.div
          key={timeUntilTabSwitch}
          initial={{ scale: 1.2, opacity: 0.8 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className={`text-[9px] flex items-center gap-1 px-1.5 py-0.5 rounded-full ${
            timeUntilTabSwitch <= 10
              ? isDarkMode
                ? "bg-red-900/50 text-red-300"
                : "bg-red-100 text-red-700"
              : timeUntilTabSwitch <= 30
              ? isDarkMode
                ? "bg-yellow-900/50 text-yellow-300"
                : "bg-yellow-100 text-yellow-700"
              : isDarkMode
              ? "bg-gray-600 text-gray-300"
              : "bg-gray-200 text-gray-600"
          }`}
        >
          <svg
            className="w-2.5 h-2.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{timeUntilTabSwitch}s</span>
        </motion.div>
      )}
    </div>
  );
};
